import { useTranslation } from 'react-i18next';

/**
 * The floor-plan key.
 *
 * Colour alone is not enough — roughly one host in twelve is colour-blind, and
 * the floor screen is read at speed across a room — so every swatch is labelled
 * rather than relying on the fill.
 */
const STATUSES: Array<{ key: string; swatch: string }> = [
  { key: 'floor.free', swatch: 'bg-emerald-200 border-emerald-500' },
  { key: 'floor.held', swatch: 'bg-amber-200 border-amber-500' },
  { key: 'floor.arrived', swatch: 'bg-sky-200 border-sky-500' },
  { key: 'floor.seated', swatch: 'bg-blue-200 border-blue-600' },
  { key: 'floor.dessert', swatch: 'bg-purple-200 border-purple-500' },
  { key: 'floor.checkDropped', swatch: 'bg-orange-200 border-orange-500' },
  { key: 'floor.bussing', swatch: 'bg-slate-300 border-slate-500' },
];

export function TableStatusLegend() {
  const { t } = useTranslation();

  return (
    <ul className="flex flex-wrap items-center gap-x-3 gap-y-1" aria-label={t('floor.legend')}>
      {STATUSES.map((status) => (
        <li key={status.key} className="flex items-center gap-1.5 text-xs text-slate-600">
          <span className={`h-3 w-3 rounded border ${status.swatch}`} aria-hidden />
          {t(status.key)}
        </li>
      ))}
    </ul>
  );
}
